import React, { useEffect, useState } from "react";
import {
  User,
  Smartphone,
  Upload,
  FileSignature,
  Loader,
  FileJson,
  Copy,
  Loader2,
  Check,
  FileText,
  ExternalLink,
  Download,
  CheckCircle,
  Info,
  ArrowRight,
  UserCheck,
  ShieldCheck,
  Phone,
  MapPin,
  Calendar,
  XCircle,
} from "lucide-react";

import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { verifyESigner } from "../../../Services/ApiTestService/apiTestService"; // Update this import if you have a new service for ESigner

const ESigner = () => {
  const { serviceName } = useService();
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(false);

  // const [isFetchingDetails, setIsFetchingDetails] = useState(false)

  const [savedDocId, setSavedDocId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    document: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      document: file || null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Using FormData object to handle the file upload properly
    const payload = new FormData();
    if (profileData) {
      payload.append("api_id", profileData.user_id);
      payload.append("api_key", profileData.api_key);
      payload.append("token_id", profileData.token_id);
      payload.append("methodName", "generateToken");
      // payload.append("redirect_url", "http://localhost:3000/e-signer");
      payload.append("redirect_url", "https://apiuser.idspay.in/e-signer");
    }

    payload.append("name", formData.name);
    payload.append("mobile", formData.mobileNumber);
    if (formData.document) {
      payload.append("document", formData.document);
    }

    console.log("Initiating E-Sign Request for:", formData.name);

    try {
      const res = await verifyESigner(payload);

      if (res?.status?.code === 200) {
        showSuccessToast(
          res?.data?.message ||
            res?.message ||
            res?.data?.data?.message ||
            "Success!",
        );
        if (res?.data?.docId) {
          localStorage.setItem("esignDocId", res?.data?.docId);
        } else {
          showErrorToast("No Document ID Found");
        }

        if (res?.data?.url) {
          window.location.href = res?.data?.url;
        } else {
          showErrorToast("No Redirect URL Found");
        }
      } else {
        showErrorToast(
          res?.data?.message ||
            res?.message ||
            res?.data?.data?.message ||
            "An error occurred",
        );
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Failed to process request.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDetails = async (docId) => {
    if (!docId) {
      showErrorToast("No Document ID Found")
    }
    const payload = new FormData();
    if (profileData) {
      payload.append("api_id", profileData.user_id);
      payload.append("api_key", profileData.api_key);
      payload.append("token_id", profileData.token_id);
      payload.append("methodName", "fetchDetails");
    }

    payload.append("docId", docId);
    console.log("Fetching E-Sign Request for:", formData.name || "you");
    setIsLoading(true);

    try {
      const res = await verifyESigner(payload);

      if (res?.status?.code === 200) {
        setResponseData(res);
        showSuccessToast(
          res?.data?.message ||
            res?.message ||
            res?.data?.data?.message ||
            "Success!",
        );
          localStorage.removeItem("esignDocId");
          setSavedDocId(null);
      } else {
        showErrorToast(
          res?.data?.message ||
            res?.message ||
            res?.data?.data?.message ||
            "An error occurred",
        );
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Failed to process request.");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

   useEffect(() => {
    if(!profileData) return
    const savedDoc = localStorage.getItem("esignDocId");
    if (savedDoc === null || savedDoc === undefined || savedDoc === "") return;
    setSavedDocId(savedDoc);
    fetchDetails(savedDoc);
  }, [profileData]);

  //  useEffect(() => {
  //   const savedDoc = localStorage.getItem("esignDocId");
  //   if (savedDoc === null || savedDoc === undefined || savedDoc === "") return;
  //   setSavedDocId(savedDoc);
  // }, []);

  const validform =
    formData?.name && formData?.mobileNumber && formData?.document;

  return (
    <>
      <Seo />
      <Header heading={serviceName || "E-Signer"} />

      {isLoading && !responseData && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin text-blue-600" />
        </div>
      )}

      <div className="min-h-screen w-full bg-slate-50 flex flex-col items-center justify-start p-4 pt-2">
         {/* Saved Document Alert Banner  */}
        {/* {savedDocId && (
          <div className="mb-6 w-full bg-blue-50/80 border border-blue-100 rounded-xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 animate-in fade-in slide-in-from-top-2 duration-300">
            <div className="flex items-start sm:items-center gap-3">
              <div className="bg-blue-100/50 p-2 rounded-full text-blue-600 flex-shrink-0">
                <Info className="w-5 h-5" />
              </div>
              <div>
                <h4 className="text-sm font-semibold text-blue-900">
                  Saved Document Found
                </h4>
                <p className="text-sm text-blue-700/90 mt-0.5">
                  Would you like to fetch and download your previous document?
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3 w-full sm:w-auto">
              <button
                type="button"
                onClick={() => {
                  localStorage.removeItem("esignDocId");
                  setSavedDocId(null);
                }}
                className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium text-red-700 bg-red-100 border border-red-200 hover:bg-red-600 hover:text-red-50 rounded-lg transition-all focus:outline-none focus:ring-2 focus:ring-slate-200"
              >
                
                  <div className="flex items-center justify-center gap-2">
                    <XCircle className="w-4 h-4" />
                    <span>Remove Document</span>
                  </div>
              </button>

              <button
              disabled={isLoading}
                type="button"
                onClick={() => fetchDetails(savedDocId)}
                className="flex-1 sm:flex-none flex items-center disabled:cursor-not-allowed justify-center gap-1.5 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-blue-50"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Processing...</span>
                  </>
                ) : (
                  <>
                    <span>Fetch Details</span>
                    <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
            </div>
          </div>
        )} */}

        {/* Main Card */}
        <div className="w-full max-w-xl bg-white border border-slate-200 shadow-sm rounded-xl py-2 px-6 md:px-8">
          {/* Header Section */}
          <div className="flex flex-col items-center text-center  pb-6 border-b border-slate-100">
            <div className="bg-blue-50 p-3 rounded-full text-blue-600 mb-3">
              <FileSignature className="w-8 h-8" />
            </div>
            <h2 className="text-xl font-bold text-slate-800">
              Initiate E-Signature
            </h2>
            <p className="text-sm text-slate-500 mt-1">
              Upload a document and provide signer details securely.
            </p>
          </div>

          {/* Input Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
           <div className="flex justify-center gap-4">
             {/* Name Field */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">
                Full Name
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                  <User className="w-4 h-4" />
                </div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:bg-white transition-all text-slate-800 placeholder:text-slate-400"
                  placeholder="Enter signer's full name"
                  required
                />
              </div>
            </div>

            {/* Mobile Number Field */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">
                Mobile Number
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                  <Smartphone className="w-4 h-4" />
                </div>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:bg-white transition-all text-slate-800 placeholder:text-slate-400"
                  placeholder="e.g., 9876543210"
                  pattern="[0-9]{10}"
                  maxLength="10"
                  required
                />
              </div>
            </div>
           </div>

            {/* Document Upload Field */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">
                Upload Document
              </label>
              <div className="relative">
                <input
                  type="file"
                  id="document-upload"
                  name="document"
                  onChange={handleFileChange}
                  className="hidden"
                  accept=".pdf,.doc,.docx"
                  required
                />
                <label
                  htmlFor="document-upload"
                  className={`flex items-center justify-center w-full px-4 py-4 text-sm border-2 border-dashed rounded-lg cursor-pointer transition-all ${
                    formData.document
                      ? "border-green-400 bg-green-50 text-green-700"
                      : "border-slate-300 bg-slate-50 text-slate-500 hover:bg-slate-100 hover:border-slate-400"
                  }`}
                >
                  {formData.document ? (
                    <div className="flex flex-col items-center gap-1">
                      <FileText className="w-6 h-6 text-green-600 mb-1" />
                      <span className="font-medium text-green-700 truncate max-w-[100px]">
                        {formData.document.name}
                      </span>
                      <span className="text-xs text-green-600/70">
                        Click to change file
                      </span>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center gap-1">
                      <Upload className="w-6 h-6 text-slate-400 mb-1" />
                      <span className="font-medium">
                        Click to upload document
                      </span>
                      <span className="text-xs text-slate-400">
                        Supports PDF, DOC, DOCX
                      </span>
                    </div>
                  )}
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={!validform || isLoading}
              className={`w-full mt-6 flex items-center justify-center gap-2 py-3 px-4 rounded-lg text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                !validform || isLoading
                  ? "bg-slate-100 text-slate-400 cursor-not-allowed border border-slate-200"
                  : "bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg"
              }`}
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <FileSignature className="w-4 h-4" />
                  <span>Generate E-Sign Link</span>
                </>
              )}
            </button>
          </form>
        </div>

      {/* ---------------- RESULT SECTION ---------------- */}
        {responseData?.data && (
          <div className="mt-8 w-full max-w-5xl animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              
              {/* LEFT CARD: Document Actions */}
              <div className="bg-white border border-green-200 shadow-sm rounded-xl p-6 md:p-8 flex flex-col justify-between h-full">
                <div>
                  {/* Success Header */}
                  <div className="flex flex-col items-center text-center mb-6">
                    <div className="bg-green-100 p-3 rounded-full text-green-600 mb-3">
                      <CheckCircle className="w-8 h-8" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-800">
                      Document Processed Successfully!
                    </h3>
                    <p className="text-sm text-slate-500 mt-1">
                      Your signed document is ready for viewing and downloading.
                    </p>
                  </div>

                  {/* File Details */}
                  <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mb-6 flex items-center gap-3">
                    <div className="bg-blue-100 p-2 rounded-md text-blue-700 flex-shrink-0">
                      <FileText className="w-6 h-6" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-slate-800 truncate" title={responseData.data.fileName}>
                        {responseData.data.fileName || "document.pdf"}
                      </p>
                      <p className="text-xs text-slate-500 truncate" title={responseData.data.docId}>
                        ID: {responseData.data.docId}
                      </p>
                    </div>
                    {responseData.data.status && (
                      <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-700 uppercase">
                        {responseData.data.status}
                      </span>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3">
                  {responseData.data.signedPdfUrl && (
                    <a
                      href={responseData.data.signedPdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-2 py-2.5 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-semibold transition-all shadow-sm hover:shadow"
                    >
                      <ExternalLink className="w-4 h-4" />
                      View Signed PDF
                    </a>
                  )}

                 
                </div>
              </div>

              {/* RIGHT CARD: Signer Details */}
              <div className="bg-white border border-slate-200 shadow-sm rounded-xl p-6 md:p-8">
                <div className="flex items-center gap-2 text-slate-800 font-bold text-lg mb-4 pb-3 border-b border-slate-100">
                  <UserCheck className="w-5 h-5 text-blue-600" />
                  <h3>Signer Details</h3>
                </div>

                {responseData.data.signerDetails && responseData.data.signerDetails.length > 0 ? (
                  responseData.data.signerDetails.map((signer, index) => (
                    <div key={index} className="space-y-4">
                      {/* Name & Aadhaar Badge */}
                      <div className="flex items-start justify-between gap-2">
                        <div>
                          <p className="text-base font-bold text-slate-800">
                            {signer.signerName || signer.name}
                          </p>
                          <p className="text-xs text-slate-500">
                            Type: <span className="capitalize">{signer.signerType}</span>
                          </p>
                        </div>
                        {signer.aadhaarSuffix && (
                          <div className="flex items-center gap-1 text-xs font-medium text-slate-600 bg-slate-100 px-2.5 py-1 rounded-md border border-slate-200">
                            <ShieldCheck className="w-3.5 h-3.5 text-blue-600" />
                            <span>{signer.aadhaarSuffix}</span>
                          </div>
                        )}
                      </div>

                      {/* Detail Grid */}
                      <div className="grid grid-cols-2 gap-3 text-sm bg-slate-50 p-4 rounded-lg border border-slate-100">
                        <div>
                          <p className="text-xs text-slate-400">Mobile</p>
                          <p className="font-medium text-slate-700 flex items-center gap-1 mt-0.5">
                            <Phone className="w-3.5 h-3.5 text-slate-400" />
                            {signer.mobile || "N/A"}
                          </p>
                        </div>

                        <div>
                          <p className="text-xs text-slate-400">Gender / DOB</p>
                          <p className="font-medium text-slate-700 mt-0.5">
                            {signer.gender || "N/A"} {signer.dob ? `(${signer.dob})` : ""}
                          </p>
                        </div>

                        <div>
                          <p className="text-xs text-slate-400">Location</p>
                          <p className="font-medium text-slate-700 flex items-center gap-1 mt-0.5">
                            <MapPin className="w-3.5 h-3.5 text-slate-400" />
                            {signer.signerState || signer.state || "N/A"}
                            {signer.postalCode ? ` - ${signer.postalCode}` : ""}
                          </p>
                        </div>

                        <div>
                          <p className="text-xs text-slate-400">Status</p>
                          <span className="inline-block mt-0.5 px-2 py-0.5 text-xs font-semibold rounded bg-green-100 text-green-700 capitalize">
                            {signer.state}
                          </span>
                        </div>
                      </div>

                      {/* Signed On Date */}
                      {signer.signedOn && (
                        <div className="flex items-center gap-1.5 text-xs text-slate-500 pt-1">
                          <Calendar className="w-3.5 h-3.5 text-slate-400" />
                          <span>Signed on: <strong className="text-slate-700">{signer.signedOn}</strong></span>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-sm text-slate-500 py-4 text-center">
                    No signer information available.
                  </p>
                )}
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default ESigner;
